export const isAdsDisabledRoute = (path: string) => {
  const p = path !== '/' ? path.replace(/\/+$/, '') : path

  if (p === '/login') return true
  if (p.startsWith('/cms')) return true
  if (p.startsWith('/korisnicki-profil')) return true

  return false
}
